import React from 'react'

const Add = () => {
  return (
    <div>
      <svg
        width="15"
        height="15"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_2045_54057"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="15"
          height="15"
        >
          <rect width="11" height="11" fill="#3249D7" />
        </mask>
        <g>
          <path
            d="M5.04163 8.70768V5.95768H2.29163V5.04102H5.04163V2.29102H5.95829V5.04102H8.70829V5.95768H5.95829V8.70768H5.04163Z"
            fill="#3249D7"
          />
        </g>
      </svg>
    </div>
  )
}

export default Add
